import axios from 'axios'
import store from '../store'
// import qs from 'qs'

axios.defaults.timeout = 20000
axios.defaults.baseURL = 'https://camel-battery.com/cms/api'
axios.defaults.headers.post['Content-Type'] = 'application/json charset=UTF-8'
// request拦截器
axios.interceptors.request.use(
  config => {
    if (config.url == '/userLog/insert') {
      config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('accessToken')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// respone拦截器  //拦截响应response，并做一些错误处理
axios.interceptors.response.use(

  response => {
    const data = response.data
    return data
  },
  error => {
    console.log(error,'error')
    if(error.config.url == '/userLog/insert'){
      if(error.response.status == '401'){
        sessionStorage.removeItem('accessToken')
      }
    }
    if (error.message.indexOf('timeout') != -1) {
      alert('本次操作请求超时，请重新操作')
    } else {
      // alert('系统请求异常')
    }
  }
)


export default {
  get(url, params = {}) {
    var data = params || {}
    return axios.get(url, {
      params: data
    })
  },
  post(url, params = { data: {}, contentType: '' }) {
    if (params.contentType && params.contentType == 'form') {
      return axios.post(url, params.data , {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    } else if (params.contentType && params.contentType == 'formData') {
      return axios.post(url, params.data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    } else {
      return axios.post(url, params.data || params)
    }
  },
  getFile(url, params = {}) {
    var data = params || {}
    data['sendTime'] = new Date().getTime()
    return axios.get(url, {
      responseType: 'blob',
      params: data
    })
  },
  getCache(url, params = {}) {
    var data = params || {}
    return axios.get(url, {
      params: data
    })
  },
}